module.exports = __webpack_public_path__ + "static/media/sweet-circuuts2.1c03517b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/shoes/sweet-circuuts2.png
// module id = 65
// module chunks = 0